module.exports = __webpack_public_path__ + "img/bonore.680370ba.webp";